const c = {
  name: "Settings",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,7.5c-2.5,0-4.5,2-4.5,4.5c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5C16.5,9.5,14.5,7.5,12,7.5z M9.5,12
			c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5S9.5,13.4,9.5,12z"/>
		<path class="st0" d="M10,1L9.6,0.2L8.8,0.5C6.8,1,5,2,3.6,3.5L3,4l0.4,0.7C3.9,5.4,4,6.3,3.5,7.1C3.1,7.9,2.3,8.3,1.4,8.2l-0.8,0
			L0.4,9C0.2,9.9,0,11,0,12s0.2,2.1,0.4,3l0.2,0.8l0.8,0c0.8,0,1.7,0.4,2.1,1.1l0,0c0.4,0.8,0.4,1.7-0.1,2.4L3,20l0.6,0.6
			C5,22,6.8,23,8.8,23.6l0.8,0.2l0.4-0.7c0.4-0.8,1.2-1.3,2-1.3c0.9,0,1.6,0.5,2,1.3l0.4,0.7l0.8-0.2c2-0.6,3.8-1.6,5.2-3L21,20
			l-0.4-0.7c-0.5-0.7-0.5-1.6-0.1-2.4c0.4-0.8,1.3-1.2,2.1-1.1l0.8,0l0.2-0.8c0.2-1,0.4-2,0.4-3s-0.2-2.1-0.4-3l-0.2-0.8l-0.8,0
			c-0.8,0-1.7-0.4-2.1-1.1l0,0c-0.4-0.8-0.4-1.7,0.1-2.4L21,4l-0.6-0.6C19,2,17.2,1,15.2,0.5l-0.8-0.2L14,1c-0.4,0.8-1.2,1.3-2,1.3
			C11.1,2.2,10.4,1.7,10,1z M12,4.2c1.4,0,2.6-0.6,3.3-1.6c1.2,0.4,2.2,1,3.1,1.8c-0.5,1.2-0.4,2.5,0.3,3.7c0.7,1.2,1.8,1.9,3.1,2.1
			c0.1,0.6,0.2,1.2,0.2,1.8c0,0.6-0.1,1.2-0.2,1.8c-1.2,0.2-2.4,0.9-3.1,2.1c-0.7,1.2-0.7,2.5-0.3,3.7c-0.9,0.8-2,1.4-3.1,1.8
			c-0.8-1-2-1.6-3.3-1.6c-1.4,0-2.6,0.6-3.3,1.6c-1.2-0.4-2.2-1-3.1-1.8c0.5-1.2,0.4-2.5-0.3-3.7c-0.7-1.2-1.8-1.9-3.1-2.1
			C2.1,13.2,2,12.6,2,12c0-0.6,0.1-1.2,0.2-1.8C3.4,10,4.6,9.3,5.2,8.1C5.9,6.9,6,5.6,5.5,4.4c0.9-0.8,2-1.4,3.1-1.8
			C9.4,3.6,10.6,4.2,12,4.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Settings
};
